//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    defaultValue: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      options: null,
      append: {},
      rules: []
    };
  },
  computed: {
    values: function values() {
      // Depends on whether the field is single or multiple
      if (this.$type.isArray(this.fieldModel)) {
        return this.fieldModel.length > 0 ? this.fieldModel : this.emptyValue;
      } else {
        return [this.fieldModel];
      } // return this.emptyValue;

    },
    // To avoid empty param error
    emptyValue: function emptyValue() {
      return [null];
    }
  },
  methods: {
    $ready: function $ready() {
      this.options = this.normalizedOptions();
      this.append = this.spec.append || {};
      this.rules = this.$validation();

      if (this.defaultValue) {
        this.fieldModel = this.defaultValue;
      }
    },
    normalizedOptions: function normalizedOptions() {
      return this.spec.options.map(function (i) {
        switch (i.type) {
          case "label":
            return {
              header: i.text
            };

          case "divider":
            return {
              divider: true
            };

          default:
            return i;
        }
      });
    },
    classes: function classes() {
      return this.$classes().concat("g-text-field--hintless");
    },
    onChange: function onChange() {
      var _this = this;

      Utils.type.ifObject(this.spec.onChange, function (onChange) {
        _this.$nextTick(function () {
          GLib.action.execute(onChange, _this);
        });
      });
    }
  }
};